module.exports = __webpack_public_path__ + "img/signal_wifi_4_bar-red.9edaf57a.svg";